import { PilotSourceOption } from '@services/PilotOnboardingService';

export interface PilotSourceOptionItem {
    id: PilotSourceOption;
    title: string;
}

export const pilotSourceOptions: PilotSourceOptionItem[] = [
    { id: 'instagram', title: 'Instagram' },
    { id: 'mailOutbound', title: 'Mail outbound'.localized() },
    { id: 'partnerPeru', title: 'Partner - Perú' },
    { id: 'partnerUruguay', title: 'Partner - Uruguay' },
    { id: 'partnerGuatemala', title: 'Partner - Guatemala' },
    { id: 'partnerThompsonReuters', title: 'Partner - Thompson Reuters' },
    { id: 'press', title: 'Prensa'.localized() },
    { id: 'google', title: 'Google' },
    { id: 'linkedin', title: 'LinkedIn' },
    { id: 'other', title: 'Otro'.localized() },
];

export const getPilotSourceLabel = (value: string | undefined): string | undefined => {
    return pilotSourceOptions.find((option) => option.id === value)?.title;
};
